import { render, staticRenderFns } from "./BehaviourCheck.vue?vue&type=template&id=799ac24d&scoped=true&"
import script from "./BehaviourCheck.vue?vue&type=script&lang=js&"
export * from "./BehaviourCheck.vue?vue&type=script&lang=js&"
import style0 from "./BehaviourCheck.vue?vue&type=style&index=0&id=799ac24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799ac24d",
  null
  
)

export default component.exports